import { createTheme } from '@mui/material';

import { getDefaultTheme } from './utils';

import type { Direction } from '@mui/material';

export const useCustomTheme = (direction: Direction = 'ltr') => {
  const initTheme = createTheme({ direction });
  const defaultTheme = getDefaultTheme(initTheme);

  return {
    ...defaultTheme,
  };
};
